import { requiredRule, minMaxLengthRule } from './utils'
import { deliveryWebhookMetadata } from './static_metadata'

const rcsMetadata = {
  channel_type: 'rcs',
  fixedHeader: [
    {
      type: 'select',
      key: 'provider_type', // IMPORTANT: Cant change this
      value: 'rcs_infobip',
      label: 'RCS Provider Type',
      placeholder: 'Please select',
      options: [
        {
          value: 'rcs_infobip',
          label: 'Infobip RCS'
        }
      ],
      rules: [requiredRule('Email Provider Type')]
    },
    {
      type: 'input',
      key: 'provider_name', // Key to send request body to server
      value: '',
      label: 'Name Your Configuration',
      placeholder: 'Give provider name',
      rules: [requiredRule('Name Your Configuration'), minMaxLengthRule('Name Your Configuration', 1, 2000)]
    }
  ],

  dynamicProviders: {
    rcs_infobip: {
      fields: [
        {
          type: 'input',
          key: 'url',
          value: '',
          label: 'Api Endpoint URL',
          placeholder: 'Enter api endpoint url',
          rules: [requiredRule('api endpoint url'), minMaxLengthRule('api endpoint url', 1, 100)]
        },
        {
          type: 'input',
          key: 'senderId',
          value: '',
          label: 'Sender Id',
          placeholder: 'Sender Id',
          rules: [requiredRule('Sender Id'), minMaxLengthRule('Sender Id', 1, 5000)]
        },
        {
          type: 'input',
          key: 'senderType',
          value: '',
          label: 'Sender Type',
          placeholder: 'Sender Type',
          rules: [requiredRule('Sender Type'), minMaxLengthRule('Sender Type', 1, 5000)]
        },
        {
          type: 'input',
          key: 'token',
          value: '',
          label: 'Token',
          placeholder: 'Enter token',
          rules: [requiredRule('Token'), minMaxLengthRule('Token', 1, 100)]
        },
        deliveryWebhookMetadata({
          attrs: {
            emailProviderType: 'rcs_infobip'
          }
        })
      ]
    }
  }
}

export default rcsMetadata
